const Benchmark = 'Benchmark';
const BillEndUseUsage = 'Energy Billing Report';
const CO2 = 'CO2 Report';
const DashboardSubmeterV2 = 'Submeter Dashboard V2';
const DashboardUtilityData = 'Dashboard Utility Data';
const DashboardUtilityElectricity = 'Dashboard Utility Electricity';
const EndUse = 'End Use Report';
const HourlyEndUse = 'Hourly End Use Report';
const IndoorAirQuality = 'Indoor Air Quality';
const IndoorAirQualityNew = 'IAQ Report - New Design';
const IndoorAirQualityV4 = 'IAQ Report - v4';
const LoadUsage = 'Energy Billing Report';
const MonthlyUtility = 'Monthly Utility Report';
const NOC = 'NOC Report';
const PowerQuality = 'Power Quality';
const PowerQualityV3 = 'Power Quality - v3';
const Sensor = 'Sensor Report';
const SiteStartTimeAnalytics = 'Site Start Time Analtycs';
const TenentBilling = 'Tenent Billing';
const TenantBillingWideFormat = 'Tenant Billing Wide Format';
const UtilityForecast = 'Utility Forecast Report';
const RealTime = 'Realtime Report';
const ERCOT4CP = 'ERCOT 4 CP Report-2025';
const EndUseBreakdown = 'End Use Breakdown Report';
const Thermostat = 'Thermostat Report';
const Solar = 'Solar Report';
const SolarV2 = 'Solar Report - v2';

export default {
  Benchmark,
  BillEndUseUsage,
  CO2,
  DashboardSubmeterV2,
  DashboardUtilityData,
  DashboardUtilityElectricity,
  EndUse,
  HourlyEndUse,
  IndoorAirQuality,
  IndoorAirQualityNew,
  IndoorAirQualityV4,
  LoadUsage,
  MonthlyUtility,
  NOC,
  PowerQuality,
  PowerQualityV3,
  Sensor,
  SiteStartTimeAnalytics,
  TenentBilling,
  TenantBillingWideFormat,
  UtilityForecast,
  RealTime,
  ERCOT4CP,
  EndUseBreakdown,
  Thermostat,
  Solar,
  SolarV2,
};
